module.exports = __webpack_public_path__ + "img/0c14e6d8.png";